export const bulkCalendarDrawer = {
  header: {
    eyebrow: "تعديل جماعي",
    title: "التقويم الجماعي",
    subtitle: "أغلق أو افتح أو عدّل عدة وحدات في آنٍ واحد.",
  },
  actions: {
    close: {
      label: "إغلاق التواريخ",
      hint: "يطبّق حظرًا يدويًا مع احترام الحجوزات والمزامنة.",
    },
    open: {
      label: "فتح التواريخ",
      hint: "يعيد فتح الأيام المحددة فقط دون المساس ببقية الإغلاق.",
    },
    price: {
      label: "تغيير السعر",
      hint: "يحدّث سعر الليلة للتواريخ وأماكن الإقامة المختارة.",
    },
    minStay: {
      label: "الحد الأدنى للإقامة",
      hint: "يحدّد الحد الأدنى لعدد الليالي لكل تاريخ بشكل جماعي.",
    },
  },
  microcopy: {
    close: "حظر يدوي",
    open: "فتح جزئي",
    price: "سعر الليلة",
    minStay: "أدنى عدد ليالٍ",
  },
  step1: {
    title: "ما الذي تريد تطبيقه",
    hintEmpty: "اختر إجراءً للبدء.",
  },
  step2: {
    title: "أين تطبّقه",
    selectedCount: "{selected} من {total} محدد",
    selectVisible: "المرئية",
    selectAll: "الكل",
    clear: "مسح",
    searchPlaceholder: "ابحث عن مكان إقامة…",
    empty: "لا توجد أماكن إقامة مطابقة لبحثك.",
  },
  step3: {
    title: "النطاق والأيام",
    datesInRange: "{count} تاريخ في النطاق | {count} تواريخ في النطاق",
    from: "من",
    to: "إلى",
    presetAll: "الكل",
    presetWeekdays: "الاثنين–الجمعة",
    presetWeekend: "نهاية الأسبوع",
  },
  step4: {
    closeReasonTitle: "سبب الإغلاق",
    availabilityTitle: "التوافر",
    closeReasonHint: "اختياري — سيُسجَّل مع الحظر.",
    availabilityHint: "يتم إغلاق البيع (إيقاف البيع)؛ ويُحتفظ بالتوافر. غيّره فقط إذا أردت.",
    closeCommentPlaceholder: "مثال: صيانة أو استخدام المالك",
    availabilityPlaceholder: "الغرف المعروضة للبيع (فارغ = الإبقاء)",
    openAvailabilityHint: "يعيد فتح البيع. حدّد عدد الغرف المعروضة (فارغ = الإبقاء على الحالي).",
    availabilityPlaceholderOpen: "الغرف المعروضة للبيع",
  },
  ratePlan: {
    title: "التسعيرة المراد تعديلها",
    hint: "لهذا النوع عدة تسعيرات. اختر التسعيرة (أو التسعيرات) التي تريد تطبيق {target} عليها. تُضبط المشتقّة تلقائيًا.",
    targetPrice: "السعر",
    targetMinStay: "الحد الأدنى للإقامة",
    default: "قياسية",
    roomsCount: "{count} غرفة | {count} غرف",
    multiUnitNote: "سيُطبَّق على كل غرفة تملك التسعيرة المختارة.",
    fallbackName: "تسعيرة",
  },
  price: {
    title: "سعر الليلة الجديد",
    hint: "سيُطبَّق على التواريخ والوحدات والتسعيرات المختارة.",
    mixedCurrencyWarning: "اختر أماكن إقامة بالعملة نفسها فقط.",
    placeholder: "القيمة",
    placeholderCurrency: "القيمة بعملة {currency}",
    hintPercent: "يرفع أو يخفض السعر الحالي لكل ليلة.",
    modeGroupLabel: "نوع تغيير السعر",
    modeFixed: "سعر ثابت",
    modeFixedHint: "المبلغ نفسه في كل الليالي.",
    modePercent: "نسبة مئوية",
    modePercentHint: "على سعر كل ليلة على حدة.",
    modeAmount: "مبلغ",
    modeAmountHint: "إضافة أو خصم على كل ليلة.",
    amountPlaceholder: "مثال 10",
    amountHint: "يُضاف إلى سعر كل ليلة الحالي. بعلامة − ينخفض.",
    percentPlaceholder: "مثال: 20",
    percentHint: "تُحتسب كل ليلة انطلاقًا من سعرها الخاص. علامة − تخفض السعر (بين {min} % و{max} %).",
    toggleSign: "التبديل بين الرفع والخفض",
    invalidPercent: "أدخل نسبة بين {min} % و{max} % وتختلف عن 0.",
  },
  minStay: {
    title: "الحد الأدنى للإقامة",
    hint: "أدنى عدد من الليالي لكل تاريخ.",
    placeholder: "مثال: 2",
  },
  summary: {
    empty: "اختر الوحدات والنطاق.",
    unitOne: "وحدة",
    unitMany: "وحدات",
    dateOne: "تاريخ",
    dateMany: "تواريخ",
    ready: "{propertyCount} {propertyLabel} · {dateCount} {dateLabel} جاهزة للتطبيق.",
    nightOne: "ليلة",
    nightMany: "ليالٍ",
    readyPriceFixed: "{propertyCount} {propertyLabel} · سيضع {price} {currency} في {dateCount} {nightLabel}.",
    readyPricePlus: "{propertyCount} {propertyLabel} · سيرفع سعر {dateCount} {nightLabel} بمقدار {amount} {currency}.",
    readyPriceMinus: "{propertyCount} {propertyLabel} · سيخفض سعر {dateCount} {nightLabel} بمقدار {amount} {currency}.",
    readyPriceUp: "{propertyCount} {propertyLabel} · سيرفع سعر {dateCount} {nightLabel} بنسبة {percent} %.",
    readyPriceDown: "{propertyCount} {propertyLabel} · سيخفض سعر {dateCount} {nightLabel} بنسبة {percent} %.",
  },
  footer: {
    cancel: "إلغاء",
    apply: "تطبيق التغييرات",
    applying: "جارٍ التطبيق…",
  },
  weekdays: {
    mon: { short: "ن", long: "الاثنين" },
    tue: { short: "ث", long: "الثلاثاء" },
    wed: { short: "ر", long: "الأربعاء" },
    thu: { short: "خ", long: "الخميس" },
    fri: { short: "ج", long: "الجمعة" },
    sat: { short: "س", long: "السبت" },
    sun: { short: "ح", long: "الأحد" },
  },
  ownerBlockComment: "حظر من قِبَل المالك",
};
